import React from 'react';
import Card from '@mui/material/Card';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import {
    ResponsiveButton,
    ResponsiveButtonWithConfirmation,
} from 'ui/ResponsiveButton/ResponsiveButton';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { trackEvent } from 'helpers/trackerHelpers';
import { styled } from '@mui/material/styles';

type Props = {
    toggleEditMode: FlowAnyFunction;
    cancelDashboardEdition: FlowAnyFunction;
    saveDashboardEdition: FlowAnyFunction;
};

const StyLayoutButtons = styled('div', {
    name: 'StyLayoutButtons',
})({
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > *:not(:last-of-type)': {
        marginRight: '1rem',
    },
});

const StyCardWrapper = styled(Card, {
    name: 'StyCardWrapper',
})(({ theme }) => ({
    padding: '1rem',
    background: theme.palette.primary.background,
    width: '100%',
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
}));

function EditionLayoutBanner(props: Props): React.ReactElement {
    const { t } = useTranslation('components');
    const cancelEdition = () => {
        props.toggleEditMode();
        props.cancelDashboardEdition();
    };
    const saveEdition = () => {
        props.toggleEditMode();
        props.saveDashboardEdition();
    };

    // tracking on amplitude when user enters layout menu
    React.useEffect(() => {
        trackEvent('decision/dashboard/layout-mode-on');
    }, []);

    return (
        <StyCardWrapper elevation={1}>
            <div>
                <Typography variant="h4">
                    {t('dashboardHeader.layoutModeTitle')}
                </Typography>
                <Typography variant="body1">
                    {t('dashboardHeader.layoutModeDescription')}
                </Typography>
            </div>
            <StyLayoutButtons>
                <ResponsiveButton
                    icon={<SaveIcon />}
                    label={t('dashboardHeader.editDone')}
                    onClick={saveEdition}
                    extra={{ variant: 'contained' }}
                />

                <ResponsiveButtonWithConfirmation
                    icon={<CancelIcon />}
                    label={t('dashboardHeader.editCancel')}
                    onSubmitClick={cancelEdition}
                    dialogTitle={t('dashboardHeader.editCancel')}
                    extra={{ variant: 'outlined' }}
                >
                    {t('dashboardHeader.cancelConfirmation')}
                </ResponsiveButtonWithConfirmation>
            </StyLayoutButtons>
        </StyCardWrapper>
    );
}

export default EditionLayoutBanner;
